import classnames from 'classnames';

import style from './Badge.module.scss';

export enum BadgeThemes {
    // @ts-ignore
    WARN = style.warn,
}

export interface BadgeProps {
    text: string;
    theme?: BadgeThemes;
}

export function Badge({ text, theme = BadgeThemes.WARN }: BadgeProps) {
    return <div className={classnames([style.root, style.default, theme])}>{text}</div>;
}
